

const routes = {
  contact: "/contact-us",
  join: "/join-us",
  home: "/",
  who: "/who-we-are",
  projects: "/projects",
  community: "/community",
  project: (slug = ":slug") => `/projects/${slug}`
}

export default routes;